module.exports = __webpack_public_path__ + "static/media/Pending.7c6cf877.svg";